import type {
  AdminUserDto,
  AITestAggregateDto,
  AITestListItemDto,
  DeletedRecordsDto,
  InventoryItemDto,
  TranslationLocale,
  TranslationOverridesDto,
  TranslationWorkDto,
  TranslationModerationDto,
  ListUsersInput,
  SessionDto,
  EventsByDateRangeInput,
  MindMapAggregateDto,
  OpenCheckItemDto,
  RecentMindMapsInput,
  RecentMindMapDto,
  SubjectDto,
  SubjectOverviewDto,
  TestAttemptAggregateDto,
  UpcomingEventsInput,
  UpcomingEventDto,
  EventDto,
} from "@mmm/contracts";
import { getQuery } from "./client.js";

export const getSubjectList = () => getQuery<SubjectDto[]>("getSubjectList");
export const getSubjectOverview = (input: { subjectId: string }) =>
  getQuery<SubjectOverviewDto>("getSubjectOverview", input);
export const getAllAITests = () => getQuery<AITestListItemDto[]>("getAllAITests");
export const getMindMap = (input: { mindMapId: string }) => getQuery<MindMapAggregateDto>("getMindMap", input);
export const getMindMapPreviews = (input: { mindMapIds: string[] }) =>
  Promise.all(input.mindMapIds.map((mindMapId) => getMindMap({ mindMapId })));
export const getAITest = (input: { testId: string }) => getQuery<AITestAggregateDto>("getAITest", input);
export const getTestAttempt = (input: { attemptId: string }) =>
  getQuery<TestAttemptAggregateDto>("getTestAttempt", input);
export const getEventsByDateRange = (input: EventsByDateRangeInput) => getQuery<EventDto[]>("getEventsByDateRange", input);
export const getUpcomingEvents = (input?: UpcomingEventsInput) =>
  getQuery<UpcomingEventDto[]>("getUpcomingEvents", input ?? {});
export const getOpenCheckItems = () => getQuery<OpenCheckItemDto[]>("getOpenCheckItems");
export const getAllCheckItems = () => getQuery<OpenCheckItemDto[]>("getAllCheckItems");
export const getRecentMindMaps = (input?: RecentMindMapsInput) =>
  getQuery<RecentMindMapDto[]>("getRecentMindMaps", input ?? {});
export const getDeletedRecords = () => getQuery<DeletedRecordsDto>("getDeletedRecords");
export const getInventory = () => getQuery<InventoryItemDto[]>("getInventory");
export const getSession = () => getQuery<SessionDto>("getSession");
export const getCreditBalance = () => getQuery<{ available: number; reserved: number; lifetimeEarned: number; lifetimeSpent: number }>("getCreditBalance");
export const getCreditPricing = () => getQuery<{ version: string; starterCredits: number; generationPerQuestion: number; additionalMark: number }>("getCreditPricing");
export interface CreditTransaction {
  id: string;
  amount: number;
  source: string;
  sourceKey: string;
  createdAt: string;
}
export const listCreditTransactions = (input: { offset: number; limit: number }) =>
  getQuery<{ items: CreditTransaction[]; hasMore: boolean }>("listCreditTransactions", input);
export const listTranslationWork = (input: { locale: TranslationLocale; offset?: number }) =>
  getQuery<TranslationWorkDto>("listTranslationWork", input);
export const getTranslationOverrides = (input: { locale: TranslationLocale }) =>
  getQuery<TranslationOverridesDto>("getTranslationOverrides", input);
export const getTranslationModeration = (input: { locale: TranslationLocale }) =>
  getQuery<TranslationModerationDto>("getTranslationModeration", input);
export const listUsers = (input?: ListUsersInput) => getQuery<AdminUserDto[]>("listUsers", input ?? {});
